import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import video1 from "../../assets/images/report.mp4";
import video2 from "../../assets/images/result.mp4";

class Help extends Component {
  render() {
    return (
      <div className="page-content" style={{ paddingTop: "100px", backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
        <Container>
          <h3 className="mb-4 text-center" style={{ fontWeight: "600", color: "#343a40" }}>
            Help & Tutorials
          </h3>

          <Row className="mb-4">
            <Col md={{ size: 8, offset: 2 }}>
              <Card style={{ boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}>
                <CardBody>
                  <h5 style={{ fontWeight: "500", marginBottom: "15px" }}>
                     How to Enter Results in Software
                  </h5>
                  <video width="100%" controls style={{ borderRadius: "5px" }}>
                    <source src={video2} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col md={{ size: 8, offset: 2 }}>
              <Card style={{ boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}>
                <CardBody>
                  <h5 style={{ fontWeight: "500", marginBottom: "15px" }}>
                     How to View and Download Reports
                  </h5>
                  <video width="100%" controls style={{ borderRadius: "5px" }}>
                    <source src={video1} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Help;

